export { hasInlineImage } from './adapters/ComposeAdapters/AttachmentAdapter';
export { default as createMailComposeAdapter } from './adapters/ComposeAdapters/ComposeAdapterCreator';
export { default as createMailReadAdapter } from './adapters/ReadAdapters/ReadAdapterCreator';
